// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-container {
  width: 100vw;
  margin-top: 5vh;
  font-size: 2rem;
}

.order-table {
  border-collapse: collapse;
  width: 100%;
  text-align: flex-start;
  border-radius: 1rem;
  margin-top: 1vh;
  font-size: 1.75rem;
}

.orders-container .details-modal {
  width: 80vw;
  height: 80%;
}

.orders-container .modal-content {
  margin: rem;
}

.view-details-button,
.return-to-account-btn {
  display: inline-block;
  padding: 0.5rem 1rem;
  color: #fff;
  background-color: #3b82f6;
  border-radius: 0.25rem;
  font-size: 1.5rem;
}

.white-text-content {
  color: white;
}

.modal-content {
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px auto;
  width: auto;
  display: flex;
  flex-direction: column;
}

.close-button {
  color: #ffffff;
  font-weight: bold;
  transform: translateX(-50%);
  border: none;
  background-color: #3b82f6;
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 1rem;
}

.order-check-container {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  margin: 1rem auto;
  display: flex;
  width: 75%;
  max-width: 24rem;
  justify-content: center;
  border-radius: 1rem;
  border: 2px solid #6b7280;
  background-color: #e5e7eb;
}

.gradient-title {
  color: linear-gradient(to right, #6b7280, #3b82f6);
  background-color: transparent;
  font-size: 2rem;
  font-weight: 800;
}

.description-with-avatar {
  display: flex;
  flex-direction: row;
}
.avatar-section img {
  width: 5rem;
  height: auto;
}

.order-search-form {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  margin: 1rem auto;
  display: flex;
  width: 75%;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
}

.search-form-text {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  text-align: left;
}

.orders-header {
  display: flex;
  width: 100vw;
  justify-content: left;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: left;
}

.order-table {
  border-collapse: collapse;
  width: 90%;
  margin-left: 5vw;
  margin-right: 5vw;
}

.order-table th {
  border-bottom: 1px solid #6b7280;
  font-size: 1.75rem;
}

.orders-table-header {
  background-color: #e2e2e2;
}

.order-tables-line-item {
  border-bottom: 1px solid #6b7280;
  text-indent: 5vw;
  padding: 0.5rem;
  font-size: 1.5rem;
}

/* Order details styling */
.shipping-details,
.delivery-details {
  background-color: #f0f0f0;
  border-radius: 10px;
  margin-bottom: 5px;
}

/* Text styling for order and shipping details */
.shipping-details h1 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #247a97;
}

.shipping-details h2 {
  font-size: 1rem;
  font-weight: bold;
  color: #000000;
}

.order-items {
  margin-left: auto;
  margin-right: auto;
  font-size: 1.25rem;
  display: flex;
  justify-content: flex-start;
  text-align: center;
  font-size: 2.5rem;
}

.order-item-card {
  background-color: #f9f9f9;
  border-radius: 10px;
  margin: 10px 0;
  /* padding: 10px;  */
  display: flex;
  align-items: self-start;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
}

.order-item-card img {
  width: 75px;
  height: auto;
  border-radius: 15px;
  -o-object-fit: cover;
     object-fit: cover;
  margin-right: 5px;
}

.order-item-card .card-body {
  display: flex;
  justify-content: left;
  align-items: flex-start;
}

/* Text styling inside the card */
.order-item-card .card-body h2 {
  font-size: 1rem;
  color: #3b82f6;
  margin: 0;
  font-weight: 800;
  display: flex;
  justify-content: flex-start;
  align-items: self-start;
}

.order-item-card .card-body h3 {
  font-size: 0.8rem;
  color: #666;
  margin: 0;
  display: flex;
  justify-content: flex-start;
  align-items: self-start;
}

/* Additional global adjustments */
body {
  font-family: "Arial", sans-serif;
}

/* Ensuring that other elements have a consistent look */
table,
th,
td {
  color: #333;
}

@media (max-width: 991px) {
  .order-container .card-body {
    display: flex;
    justify-content: flex-start;
    text-align: left;
  }
  /* .orders-container .card-title {
    max-width: 20px;
    text-wrap: wrap;
  } */
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/OrdersPage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAiB;KAAjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;;;EAGE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;;;KAGG;AACL","sourcesContent":[".orders-container {\n  width: 100vw;\n  margin-top: 5vh;\n  font-size: 2rem;\n}\n\n.order-table {\n  border-collapse: collapse;\n  width: 100%;\n  text-align: flex-start;\n  border-radius: 1rem;\n  margin-top: 1vh;\n  font-size: 1.75rem;\n}\n\n.orders-container .details-modal {\n  width: 80vw;\n  height: 80%;\n}\n\n.orders-container .modal-content {\n  margin: rem;\n}\n\n.view-details-button,\n.return-to-account-btn {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  color: #fff;\n  background-color: #3b82f6;\n  border-radius: 0.25rem;\n  font-size: 1.5rem;\n}\n\n.white-text-content {\n  color: white;\n}\n\n.modal-content {\n  border-radius: 10px;\n  padding: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin: 20px auto;\n  width: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.close-button {\n  color: #ffffff;\n  font-weight: bold;\n  transform: translateX(-50%);\n  border: none;\n  background-color: #3b82f6;\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-size: 1rem;\n}\n\n.order-check-container {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  margin: 1rem auto;\n  display: flex;\n  width: 75%;\n  max-width: 24rem;\n  justify-content: center;\n  border-radius: 1rem;\n  border: 2px solid #6b7280;\n  background-color: #e5e7eb;\n}\n\n.gradient-title {\n  color: linear-gradient(to right, #6b7280, #3b82f6);\n  background-color: transparent;\n  font-size: 2rem;\n  font-weight: 800;\n}\n\n.description-with-avatar {\n  display: flex;\n  flex-direction: row;\n}\n.avatar-section img {\n  width: 5rem;\n  height: auto;\n}\n\n.order-search-form {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  margin: 1rem auto;\n  display: flex;\n  width: 75%;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  justify-content: flex-start;\n}\n\n.search-form-text {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n  text-align: left;\n}\n\n.orders-header {\n  display: flex;\n  width: 100vw;\n  justify-content: left;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: left;\n}\n\n.order-table {\n  border-collapse: collapse;\n  width: 90%;\n  margin-left: 5vw;\n  margin-right: 5vw;\n}\n\n.order-table th {\n  border-bottom: 1px solid #6b7280;\n  font-size: 1.75rem;\n}\n\n.orders-table-header {\n  background-color: #e2e2e2;\n}\n\n.order-tables-line-item {\n  border-bottom: 1px solid #6b7280;\n  text-indent: 5vw;\n  padding: 0.5rem;\n  font-size: 1.5rem;\n}\n\n/* Order details styling */\n.shipping-details,\n.delivery-details {\n  background-color: #f0f0f0;\n  border-radius: 10px;\n  margin-bottom: 5px;\n}\n\n/* Text styling for order and shipping details */\n.shipping-details h1 {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #247a97;\n}\n\n.shipping-details h2 {\n  font-size: 1rem;\n  font-weight: bold;\n  color: #000000;\n}\n\n.order-items {\n  margin-left: auto;\n  margin-right: auto;\n  font-size: 1.25rem;\n  display: flex;\n  justify-content: flex-start;\n  text-align: center;\n  font-size: 2.5rem;\n}\n\n.order-item-card {\n  background-color: #f9f9f9;\n  border-radius: 10px;\n  margin: 10px 0;\n  /* padding: 10px;  */\n  display: flex;\n  align-items: self-start;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(15px);\n}\n\n.order-item-card img {\n  width: 75px;\n  height: auto;\n  border-radius: 15px;\n  object-fit: cover;\n  margin-right: 5px;\n}\n\n.order-item-card .card-body {\n  display: flex;\n  justify-content: left;\n  align-items: flex-start;\n}\n\n/* Text styling inside the card */\n.order-item-card .card-body h2 {\n  font-size: 1rem;\n  color: #3b82f6;\n  margin: 0;\n  font-weight: 800;\n  display: flex;\n  justify-content: flex-start;\n  align-items: self-start;\n}\n\n.order-item-card .card-body h3 {\n  font-size: 0.8rem;\n  color: #666;\n  margin: 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: self-start;\n}\n\n/* Additional global adjustments */\nbody {\n  font-family: \"Arial\", sans-serif;\n}\n\n/* Ensuring that other elements have a consistent look */\ntable,\nth,\ntd {\n  color: #333;\n}\n\n@media (max-width: 991px) {\n  .order-container .card-body {\n    display: flex;\n    justify-content: flex-start;\n    text-align: left;\n  }\n  /* .orders-container .card-title {\n    max-width: 20px;\n    text-wrap: wrap;\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
